export const APP_VERSION = '1.37.1';

type AppReleaseNote = {
    version: string;
    date: string;
    notes: string[];
};

export const RELEASE_NOTES: AppReleaseNote[] = [
  	{
        version: '1.37.1',
        date: '2026-10-15',
        notes: [
            'Peças, Pedido de Peças e Datas de entrega não estavam sendo salvos ao criar um chamado'
        ]
    },
    {
        version: '1.37.0',
        date: '2026-10-13',
        notes: [
            'Ajuste no campo "Ocorrência”',
            'Ajustes na UI do histórico de chamados',
            'Implementação de modal/alerta questionando se o usuário deseja realmente fechar sem salvar ou salvar as alterações',
            'Ajustes no filtro de atribuições',
            'Sidesheet com novos filtros'
        ]
    },
    {
        version: '1.36.0',
        date: '2026-10-05',
        notes: [
            'Trazer a regional a partir do DN selecionado.',
            'Colocar o campo Km como obrigatório e Colocar o campo Responsável pelo chamado no DN como obrigatório',
            'No card no Kanban de atendimentos, o label Atualizado em, colocar um espaço entre o label e o conteúdo.',
            'Ajuste na visualização dos dados do veiculo ao vincular uma ocorrência na criação do chamado',
        ]
    },
    {
        version: '1.35.0',
        date: '2026-09-22',
        notes: [
            'Movimentar card para “Aguardando reparo” quando chamado SVT for para a etapa de “Respondido ao Dealer” e exibir a etapa no card de ocorrência vinculada'
        ],
    },
    {
        version: '1.34.0',
        date: '2026-09-21',
        notes: [
            'Ajuste no filtro de atribuição e alinhamento de texto no campo de ordenação por tempo',
            'No modal de ocorrências existentes para o chassi, incluir a opção/pergunta',
            'Permitir visualizar vídeos anexados',
            'No modal de mover chamado para outra etapa, validar o comportamento do campo “Editado com sucesso”, para garantir que a etapa atual seja apresentada.',
            'Permitir a remoção de uma ocorrência já vinculada',
            'Exibir valores filtrados por "sem atribuição" nos bignumbers',
            'Ajuste na visualização de pdfs anexados no relatório em pdf',
            'Inserir endpoints de chamados SVT na API externa do uptime'
        ],
    },
    {
        version: '1.33.0',
        date: '2026-09-14',
        notes: [
            'Filtrar chamados por status de atribuição',
            'Vincular ocorrência ao suporte',
            'Ajustar sugestão de mudança de status em Respondido ao Dealer',
            'Exibir número do chamado no aviso de ocorrências para o mesmo chassi',
            'Permitir exportação completa do chamado em PDF',
            'Ajuste no tempo de movimentação automática da etapa “Respondido ao Dealer” para “Finalizado”',
            'Ajustes no fluxo de vincular ocorrência (evitar sobrescrever dados e filtrar ocorrências por chassi no form de criação)',
            'Ajustes na ordenação por data de criação e atualização',
            'Ajustes na visualização de PDF (zoom e possibilidade de passar de um anexo para outro sem fechar o modal)',
            'Ajuste no modal de ocorrências existentes para o chassi (lista com os números de chamados abertos) e no modal de mover chamado para outra etapa (combo com as opções de etapa para mover o chamado)',
            'Criar suporte a partir de chamado do Monitor de Manutenção (ajuste no nome, de Suporte para Atendimento)',
        ],
    },
    {
        version: '1.32.0',
        date: '2026-09-04',
        notes: [
            '38028 - Preservar comentário não enviado durante a navegação no chamado',
            '38033 - Ordenar chamados por tempo de criação ou tempo na etapa',
            '38330 - Ajustar ações de edição do chamado de Suporte Volkstotal'
        ],
    },
    {
        version: '1.31.1',
        date: '2026-08-27',
        notes: [
            'Remoção do filtro por atribuição'
        ],
    },
    {
        version: '1.31.0',
        date: '2026-08-27',
        notes: [
            '35947 - Manter filtros aplicados na listagem de chamados',
            '35532 - Exibir número do chamado nos dados da solicitação',
            '36182 - Ajustar informações exibidas no card do chamado',
            '36951 - Permitir duplicação de chamados',
            '36958 - Restringir atribuição de chamados para usuários Volkswagen'
        ],
    },
    {
        version: '1.30.1',
        date: '2026-08-25',
        notes: [
            'Ajuste na geolocalização do acionamento na chamada do serviço de criação de rotas'
        ],
    },
    {
        version: '1.30.0',
        date: '2026-08-19',
        notes: [
            'Implementa volks essencial'
        ],
    },
    {
        version: '1.29.1',
        date: '2026-08-13',
        notes: [
            'Ajuste na validação dos formulários de atendimento'
        ],
    },
    {
        version: '1.29.0',
        date: '2026-08-12',
        notes: [
            '35533 - Sugerir mudança de etapa após alterações no chamado',
            '35535 - Organizar anexos por data e hora de inclusão',
            '35724 - Tornar obrigatórios os dados adicionais em todos os assuntos',
            '35725 - Disponibilizar pré-visualização de arquivos PDF',
            '35728 - Permitir edição dos dados do chamado após a abertura',
            '35729 - Revisar campos exibidos nos dados do veículo',
            '35926 - Implementar regras de negócio para gestão dos chamados'
        ],
    },
];
